// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fBn_t","subHeading":"styles_subHeading__gVbQK","heading":"styles_heading__bHdp4"};